import React from 'react';

const initialState = {
  attachments: {},
  isVoiceMemoRecording: false,
};

const MessageInputContext = React.createContext(initialState);

export default MessageInputContext;
export {
  initialState,
};
